function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
import tasks from '@/js/tasks';
import { mapMutations, mapState } from 'vuex';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import ReportList from '@/apps/customer-insigths/components/ReportList.vue';
export default {
  name: 'VisitorPresentation',
  components: {
    ReportList: ReportList
  },
  data: function data() {
    var _this = this;
    return {
      brand_id: 0,
      brandsList: [],
      company_code: '0',
      DIALOG_VISITOR_PRESENTATION: 'DIALOG_VISITOR_PRESENTATION',
      currentStep: 1,
      canUpload: true,
      mostrarBrands: false,
      highlights: [''],
      competitors: [''],
      metrics: [{
        selectedItem: '',
        value: ''
      }],
      metric_options: [{
        id: 1,
        name: 'NPS'
      }, {
        id: 2,
        name: 'PDM'
      }, {
        id: 3,
        name: 'MKS'
      }, {
        id: 4,
        name: 'Clima laboral'
      }],
      loading: false,
      month_id: 0,
      organization_id: 0,
      organizationsList: [],
      region_id: 0,
      regionsList: [],
      ORGS_WITH_BRAND: [17, 6],
      idRegionDataEntries: [],
      year_id: 0,
      yearsList: [],
      valid: false,
      monthsList: [{
        id: 1,
        name: this.translate('customer_insights.data_entry.header.january')
      }, {
        id: 2,
        name: this.translate('customer_insights.data_entry.header.february')
      }, {
        id: 3,
        name: this.translate('customer_insights.data_entry.header.march')
      }, {
        id: 4,
        name: this.translate('customer_insights.data_entry.header.april')
      }, {
        id: 5,
        name: this.translate('customer_insights.data_entry.header.may')
      }, {
        id: 6,
        name: this.translate('customer_insights.data_entry.header.june')
      }, {
        id: 7,
        name: this.translate('customer_insights.data_entry.header.july')
      }, {
        id: 8,
        name: this.translate('customer_insights.data_entry.header.august')
      }, {
        id: 9,
        name: this.translate('customer_insights.data_entry.header.september')
      }, {
        id: 10,
        name: this.translate('customer_insights.data_entry.header.october')
      }, {
        id: 11,
        name: this.translate('customer_insights.data_entry.header.november')
      }, {
        id: 12,
        name: this.translate('customer_insights.data_entry.header.december')
      }],
      rules: {
        name: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        organization: [function (v) {
          return !!v || _this.translate('customer_insights.rules.organization');
        }],
        year: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        month: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        region: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        highlight: [function (v) {
          return !!v || _this.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.min_character_insights_3');
        }, function (v) {
          return v && v.length <= 150 || _this.translate('reglas.max_character_insights_150');
        }],
        competidores: [function (v) {
          return !!v || _this.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.min_character_insights_3');
        }, function (v) {
          return v && v.length <= 45 || _this.translate('reglas.max_character_insights_45');
        }],
        numericRules: [function (value) {
          return !!value || 'Por favor ingrese un valor';
        }, function (value) {
          return /^[0-9]*$/.test(value) || 'Solo se permiten números';
        }],
        percentages: [function (v) {
          return !!v || 'El campo es requerido';
        }, function (v) {
          return /^\d+(\.\d+)?$/.test(v) || 'Debe ingresar un número válido';
        }]
      },
      cards: [{
        title: 'Paso 1: Highlights',
        src: 'step1.png',
        texto: 'Ingresa los principales highlights de tu compañía para el periodo de análisis.',
        flex: 4
      }, {
        title: 'Paso 2: Competidores',
        src: 'step2.png',
        texto: 'Ingresa los principales competidores de tu compañía para el periodo de análisis.',
        flex: 4
      }, {
        title: 'Paso 3: Métricas',
        src: 'step3.png',
        texto: 'Ingresa las métricas de tu compañía (NPS, Clima laboral, Market Share y PDM) para el periodo de análisis.',
        flex: 4
      }],
      isInlearning: false,
      INLEARNING_DOMAIN: 'inlearning.pe',
      isInretailpharma: false,
      INRETAILPHARMA_DOMAIN: 'inretailpharma.com'
    };
  },
  created: function created() {
    if (this.INLEARNING_DOMAIN === this.getDomainUser()) this.isInlearning = true;
    if (this.INRETAILPHARMA_DOMAIN === this.getDomainUser()) this.isInretailpharma = true;
    this.getRegionsList();
    this.getYears();
    this.getOrganizationsList();
    this.getReports();
  },
  beforeMount: function beforeMount() {
    this.calcPermissions();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    label: function label() {
      return {
        year: this.translate('customer_insights.label.year'),
        month: this.translate('customer_insights.label.month')
      };
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.somos1'),
        disabled: false,
        href: '/#/customer_insights/somos1_home'
      }, {
        text: this.translate('menu.customer.somos1_reports'),
        disabled: false,
        href: '/#/customer_insights/somos1'
      }, {
        text: this.translate('customer_insights.label.visitor_presentation'),
        disabled: true,
        href: ''
      }];
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    getDomainUser: function getDomainUser() {
      return window.userInfo.domain;
    },
    calcPermissions: function calcPermissions() {
      if (this.userHasRole(this.rolesINCA.INSIGHTS_USER_SOMOS1)) {
        this.canUpload = true;
      } else {
        this.canUpload = false;
      }
    },
    isMetricSelected: function isMetricSelected(selectedItem, currentIndex) {
      return !this.metrics.some(function (metric, index) {
        return index !== currentIndex && metric.selectedItem === selectedItem;
      });
    },
    getReports: function getReports() {
      var _this2 = this;
      this.setShowLoading(true);
      var params = {
        is_admin: this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN),
        has_accepted: this.has_accepted,
        section: 'Somos1'
      };
      Somos1Service.getReportsAssignments(params).then(function (response) {
        response.data.forEach(function (item) {
          var idRegionDataEntry = item.report.region.id_region_dataentry;
          if (idRegionDataEntry) {
            _this2.idRegionDataEntries.push(idRegionDataEntry);
          }
        });
        Somos1DataEntryService.getRegionsList().then(function (response) {
          _this2.regionsList = response.data;
          var filteredRegions = response.data.filter(function (region) {
            return _this2.idRegionDataEntries.includes(region.id_region);
          });
          _this2.regionsList = filteredRegions;
        });
      }).finally(function () {
        _this2.setShowLoading(false);
      });
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    OnStart: function OnStart() {
      this.currentStep = 1;
      this.highlights = [''];
      this.competitors = [''];
      this.metrics = [{
        selectedItem: '',
        value: ''
      }];
      this.openDialog(this.DIALOG_VISITOR_PRESENTATION);
    },
    changeOrganization: function changeOrganization() {
      if (this.ORGS_WITH_BRAND.includes(this.organization_id)) {
        this.mostrarBrands = true;
        this.getBrands();
        this.brand_id = 0;
      } else {
        this.mostrarBrands = false;
        this.brand_id = 0;
        this.brandsList = [];
      }
      this.changeSelects();
    },
    getBrands: function getBrands() {
      var _this3 = this;
      Somos1DataEntryService.getBrandsList(this.organization_id).then(function (response) {
        if (response && response.data) {
          console.log('response organizations');
          console.log(response);
          _this3.brandsList = response.data;
        }
      });
    },
    getRegionsList: function getRegionsList() {},
    getYears: function getYears() {
      var d = new Date();
      var thisYear = d.getFullYear();
      this.yearsList.push({
        id: thisYear - 1,
        name: thisYear - 1
      });
      this.yearsList.push({
        id: thisYear,
        name: thisYear
      });
    },
    getOrganizationsList: function getOrganizationsList() {
      var _this4 = this;
      Somos1DataEntryService.getOrganizationsList().then(function (response) {
        _this4.organizationsList = response.data.filter(function (item) {
          return item.company_code === _this4.companyCode || _this4.isInlearning && (item.company_code === '064' || item.company_code === '041' || item.company_code === '058') || _this4.isInretailpharma && (item.company_code === '074' || item.company_code === '044');
        });
        if (_this4.organizationsList.length > 0) {
          _this4.organization_id = _this4.organizationsList[0].id_organization;
          _this4.changeOrganization();
        } else {
          console.log('No matching organizations found for company code: ', _this4.companyCode);
        }
      }).catch(function (error) {
        console.error('Error fetching organizations list: ', error);
      });
    },
    changeSelects: function changeSelects() {
      if (this.region_id && this.organization_id && this.year_id && this.month_id) {
        this.verifyData();
      }
    },
    verifyData: function verifyData() {
      var _this5 = this;
      this.setShowLoading(true);
      console.log('here');
      var selectedRegion = this.regionsList.find(function (region) {
        return region.id_region === _this5.region_id;
      });
      var selectedOrganization = this.organizationsList.find(function (organization) {
        return organization.id_organization === _this5.organization_id;
      });
      var selectedBrand = this.brandsList.find(function (brand) {
        return brand.id_brand === _this5.brand_id;
      });
      var group = {
        year: this.year_id,
        month: this.month_id,
        region: selectedRegion.name,
        organization: selectedOrganization.name,
        brand: selectedBrand ? selectedBrand.name : null
      };
      var body = {
        group: group
      };
      Somos1DataEntryService.postVerifyVisitorPresentation(body).then(function (response) {
        if (response.success && response.code === 200) {
          if (response.data != null) {
            _this5.populateData(response.data);
          } else {
            console.log('no hay registros para el caso');
          }
        } else {
          tasks.toast.error('error');
        }
      }).catch(function (err) {
        console.log(err);
        tasks.toast.error('error');
        _this5.$refs.form_presentation.reset();
        _this5.onCloseDialog(_this5.DIALOG_VISITOR_PRESENTATION);
      }).finally(function () {
        _this5.setShowLoading(false);
      });
    },
    populateData: function populateData(data) {
      var _this6 = this;
      this.highlights = [];
      this.competitors = [];
      this.metrics = [];
      data.forEach(function (item) {
        if (item.section === 'Highlights') {
          _this6.highlights.push(item.text_value);
        } else if (item.section === 'Competidores') {
          _this6.competitors.push(item.text_value);
        } else if (item.section === 'Métricas') {
          var id_selected = _this6.metric_options.find(function (option) {
            return option.name === item.subsection;
          }).id;
          var numero = id_selected === 2 ? item.numeric_value : item.numeric_value * 100 + '%';
          _this6.metrics.push({
            selectedItem: id_selected,
            value: numero
          });
        }
      });
    },
    translate: function translate(key) {
      return this.$i18n.t(key);
    },
    validate: function validate() {
      return this.$refs.form_presentation.validate();
    },
    onSubmit: function onSubmit() {
      var _this7 = this;
      if (!this.validate()) {
        return;
      }
      this.setShowLoading(true);
      // event.preventDefault()
      // if (!this.validate()) {
      //   return
      // }
      var selectedRegion = this.regionsList.find(function (region) {
        return region.id_region === _this7.region_id;
      });
      var selectedOrganization = this.organizationsList.find(function (organization) {
        return organization.id_organization === _this7.organization_id;
      });
      var selectedBrand = this.brandsList.find(function (brand) {
        return brand.id_brand === _this7.brand_id;
      });
      var presentation_visitors = [];
      this.highlights.forEach(function (x) {
        presentation_visitors.push({
          section: 'Highlights',
          subsection: 'Highlights',
          year: _this7.year_id,
          month: _this7.month_id,
          date: new Date(_this7.year_id, _this7.month_id - 1, 1),
          region: selectedRegion.name,
          organization: selectedOrganization.name,
          brand: selectedBrand ? selectedBrand.name : null,
          text_value: x
        });
      });
      this.competitors.forEach(function (x) {
        presentation_visitors.push({
          section: 'Competidores',
          subsection: 'Competidores',
          year: _this7.year_id,
          month: _this7.month_id,
          date: new Date(_this7.year_id, _this7.month_id - 1, 1),
          region: selectedRegion.name,
          organization: selectedOrganization.name,
          brand: selectedBrand ? selectedBrand.name : null,
          text_value: x
        });
      });
      this.metrics.forEach(function (x) {
        presentation_visitors.push({
          section: 'Métricas',
          subsection: _this7.metric_options.find(function (option) {
            return option.id === x.selectedItem;
          }).name,
          year: _this7.year_id,
          month: _this7.month_id,
          date: new Date(_this7.year_id, _this7.month_id - 1, 1),
          region: selectedRegion.name,
          organization: selectedOrganization.name,
          brand: selectedBrand ? selectedBrand.name : null,
          numeric_value: x.selectedItem === 2 ? parseInt(x.value) : parseFloat(x.value) / 100
        });
      });
      var group = {
        year: this.year_id,
        month: this.month_id,
        region: selectedRegion.name,
        organization: selectedOrganization.name,
        brand: selectedBrand ? selectedBrand.name : null
      };
      var body = {
        data: presentation_visitors,
        group: group
      };
      console.log(body, 'body');
      Somos1DataEntryService.postCreateVisitorPresentation(body).then(function (response) {
        console.log(response);
        if (response.success && response.code === 200) {
          tasks.toast.success('La información ingresada se verá reflejada en el reporte de su presentación en un aproximado de 30 minutos.');
        } else {
          tasks.toast.error('error');
        }
      }).catch(function (err) {
        console.log(err);
        tasks.toast.error('error');
      }).finally(function () {
        _this7.setShowLoading(false);
        _this7.$refs.form_presentation.reset();
        _this7.onCloseDialog(_this7.DIALOG_VISITOR_PRESENTATION);
      });
    }
  })
};